import jmin from './../support/jMin';

export default class DevStudio_Bar {

	constructor() {
		if (DSData.options.general.enabled === 'yes' && DSData.options.bar.enabled === 'yes' && parseInt(DSData.canCollect) === 1 ) {
			this.init();
		}
	}

	/**
	 * Init bar after content loaded
	 *
	 */
	init() {
		// Get bar data
		window.DevStudio.request({request: 'bar'}, (response) => {

			// Insert bar into body
			let body = document.querySelector('body');
			body.insertAdjacentHTML('afterbegin', response.html);

			// Init bar handlers
			this.initBarHandlers();
		});
	}

	/**
	 * Add bar event handlers
	 */
	initBarHandlers() {
		let _this = this, $body = jmin('body');

		jmin('#dev-studio-bar .ds-bar-ds').on('click', function (e) {
			e.preventDefault();
			window.DevStudio.UI();
		});

		$body.addClass('ds-bar');

		let expand = window.localStorage.getItem('dev-studio_expand-bar');
		if (parseInt(expand) === 1) {
			$body.addClass('ds-bar-expand');
		}

		// Expand/Contract bar
		jmin('#dev-studio-bar .ds-bar-icon').on('click', function (e) {

			let $body = jmin('body');
			$body.toggleClass('ds-bar-expand');

			if ($body.hasClass('ds-bar-expand')) {
				window.localStorage.setItem('dev-studio_expand-bar', 1);
			} else {
				window.localStorage.setItem('dev-studio_expand-bar', 0);
			}

			_this.setToggleIcon();

			window.DevStudio.setUIPosition();
		});

		this.setToggleIcon();
	}

	/**
	 * Toggle arrow icon
	 *
	 */
	setToggleIcon() {
		if (jmin('body').hasClass('ds-bar-expand')) {
			jmin('#dev-studio-bar .ds-bar-icon .ds-icon').removeClass('ds-icon-arrow_down').addClass('ds-icon-arrow_up');
		} else {
			jmin('#dev-studio-bar .ds-bar-icon .ds-icon').removeClass('ds-icon-arrow_up').addClass('ds-icon-arrow_down');
		}
	}
}